import { render, staticRenderFns } from "./AiNewsPop.vue?vue&type=template&id=6567cd50&scoped=true"
import script from "./AiNewsPop.vue?vue&type=script&lang=js"
export * from "./AiNewsPop.vue?vue&type=script&lang=js"
import style0 from "./AiNewsPop.vue?vue&type=style&index=0&id=6567cd50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567cd50",
  null
  
)

export default component.exports